import React, { useState, useRef, useEffect } from "react";
import PageWrapper from "./components/PageWrapper";
import { useFormCtx } from "./FormContext";
import useScreenType from "./hooks/useScreenType";

import * as Const from "./_Const";

import Navbar from "./components/Navbar";
import Button from "./components/Button";

function PageErrorLogTerminal() {
  const screenType = useScreenType();
  const [data, setData] = useState();
  const { getTerminalLog, eraseTerminalLog } = useFormCtx();
  const textareaRef = useRef(null);

  useEffect(() => {
    async function scopedLoadData() {
      await readLogData();
    }

    scopedLoadData();
  }, []);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
    }
  }, [data]);

  async function readLogData() {
    const result = await getTerminalLog();
    setData(result);
  }

  async function eraseAndReloadLogData() {
    await eraseTerminalLog();
    await readLogData();
  }

  return (
    <>
      <Navbar useCustomTitle={true} customTitle={"Log terminál"} />
      <div className="flex flex-col space-y-4 mx-6 mt-4 ">
        <textarea
          className="bg-disabled text-sm w-full h-[320px] scRPIV2:text-base scRPIV2:h-[490px] scWaveShare:text-base scWaveShare:h-[580px] tvHD:text-base tvFullHD:h-[820px] tvFullHD:text-2xl tv4K:h-[1640px] tv4K:text-5xl"
          ref={textareaRef}
          value={data}
          readOnly
        />
        <div className="flex justify-centera bg-accent-darka">
          <Button
            type="primary"
            title="Načíst log z terminálu"
            showIcon={false}
            onClick={() => readLogData()}
            className="h-14 -mt-1 text-xs scRPIV2:h-20 scRPIV2:text-base scWaveShare:h-20 scWaveShare:text-base tvHD:h-20 tvHD:text-base tvFullHD:h-30 tvFullHD:text-2xl tv4K:h-44 tv4K:text-5xl tv4K:mt-4"
          />
          <Button
            title="Smazat log terminálu"
            showIcon={false}
            className="h-14 -mt-1 text-xs scRPIV2:h-20 scRPIV2:text-base scWaveShare:h-20 scWaveShare:text-base tvHD:h-20 tvHD:text-base tvFullHD:h-30 tvFullHD:text-2xl tv4K:h-44 tv4K:text-5xl tv4K:mt-4 absolute right-6 bg-error text-white"
            onClick={async () => await eraseAndReloadLogData()}
          />
        </div>
      </div>
    </>
  );
}

export default PageErrorLogTerminal;
